/**
 * Burger menu func
 * @author Matt Haynes
 * @package Dunfermline
 */

const BurgerMenu = () => {
    const burger = document.querySelector('.hamburger');
    if (!burger) return;

    burger.addEventListener('click', () => {
        burger.classList.toggle('is-active');
    });
};

export default BurgerMenu;
